import styled, { css } from "styled-components";
import { colors } from "../../../theme/theme";
import { Dropdown } from "react-bootstrap";

interface Navigation {
	show: boolean;
	showUserInfo?: boolean;
}

const wrapperModifiers = {
	show: () => css`
		left: 200px;
		transition: all 280ms ease;

		@media (max-width: 900px) {
			left: 85%;
			top: 5%;
		}
	`,

	showUserInfo: () => css`
		left: 450px;
		transition: all 280ms ease;

		@media (max-width: 900px) {
			left: 85%;
			top: 5%;
		}
	`,

	showOnlyUserInfo: () => css`
		left: 318px;
		transition: all 280ms ease;

		@media (max-width: 900px) {
			left: 85%;
			top: 5%;
		}
	`,

	showDivUserInfo: () => css`
		transform: translateX(0);
		transition: 280ms ease;
	`,
};

export const Wrraper = styled.div`
	width: 100%;
	display: flex;
	background-color: ${colors.mainColors.white_lilac};
	overflow-x: hidden;
`;

export const UserInfo = styled.div<Navigation>`
	${({ show, showUserInfo }) => css`
		display: ${showUserInfo ? "flex" : "none"};
		flex-direction: column;

		width: 250px;
		transform: translateX(calc(-100% - 2px));

		height: 100%;
		padding-top: 10px;
		margin-left: ${show ? "212px" : "80px"};
		position: fixed;
		border-right: ${showUserInfo
			? `0.5px solid ${colors.mainColors.very_light_green}`
			: ""};
		background: ${colors.greyscale.white};
		z-index: 8;
		transition: all 280ms ease;

		@media (max-width: 900px) {
			width: ${show ? "100%" : "0%"};
			height: 50%;
			margin-left: 0px;
			position: relative;
		}

		${showUserInfo && wrapperModifiers.showDivUserInfo()};
	`}
`;

export const PrivacyPolicies = UserInfo;

export const Notifications = styled(UserInfo)`
	width: 300px;
`;

export const ContentPage = styled.div<Navigation>`
	margin-left: ${({ show, showUserInfo }) =>
		show
			? showUserInfo
				? "450px"
				: "211px"
			: showUserInfo
			? "320px"
			: "80px"};
	width: 100%;

	@media (max-width: 900px) {
		display: ${({ show }) => (show ? "none" : "flex")};
		margin-left: 0px;
	}
`;

export const Kitten = styled.span<Navigation>`
	${({ show, showUserInfo }) => css`
		cursor: pointer;
		position: fixed;
		width: 25px;
		height: 25px;
		border: 2px solid ${colors.mainColors.verde_dstore};
		border-radius: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 99;
		left: 65px;
		top: 80px;
		background: ${colors.greyscale.white} !important;
		transition: all 280ms ease;

		@media (max-width: 900px) {
			top: 5% !important;
			left: ${show ? "90%" : "10px"} !important;
		}

		&:hover {
			background: ${colors.mainColors.verde_dstore} !important;

			svg {
				color: ${colors.greyscale.white} !important;
			}
		}

		svg {
			width: 15px !important;
			height: 15px !important;
			color: ${colors.mainColors.verde_dstore} !important;
		}

		${show && !showUserInfo && wrapperModifiers.show()};
		${show && showUserInfo && wrapperModifiers.showUserInfo()};
		${!show && showUserInfo && wrapperModifiers.showOnlyUserInfo()};
	`}
`;

export const Content = styled.div`
	padding: 30px;
	min-height: 100vh;
	height: 99%;
	width: 100%;
`;

/**
 * Componenetes compartilhados entre as páginas de detalhe de cada tipo de material
 */

export const CardTitle = styled.div`
	line-height: 1;
	border-radius: 4px;
	padding: 10px 16px 10px 16px;
	background-color: ${(props) =>
		props.color ? props.color : colors.mainColors.blueberry} !important;
	color: ${colors.greyscale.white};
	font-size: 16px;
`;
export const CardBody = styled.div`
	font-size: 16px;

	.collapsible .content {
		padding: 6px;
		background-color: #eeeeee;
	}
	.collapsible .header {
		background-color: #dddddd;
		padding: 6px;
		cursor: pointer;
	}

	.accordion-phase {
		.accordion-item {
			border: 0px;
			margin-bottom: 10px;
		}

		.accordion-button {
			border: 0px;
			border-radius: 4px;
			box-shadow: none;
			padding: 4px 16px !important;
		}
	}
`;
export const CardDescription = styled.div`
	background-color: ${colors.greyscale.white};
	padding: 15px;
	height: 100%;
	color: ${colors.greyscale.darker_grey};
	border-radius: 8px;

	.title {
		font-weight: bold;
	}

	.card {
		border: none !important;
	}
`;

export const CardUnity = styled.div`
	background-color: ${colors.mainColors.white_lilac};
	padding: 7px 10px;
	color: ${colors.mainColors.blueberry};
	border-radius: 4px;
	border-left: 10px solid ${colors.mainColors.verde_dstore};

	button {
		color: ${colors.mainColors.blueberry};
	}
`;

/** Estilo de toggle para o menu lateral, faz com que o Dropdown.Toggle do react-bootstrap tenha o mesmo visual que os demais itens de menu */
export const CustomToggle = styled(Dropdown.Toggle)`
	display: flex;
	align-items: center;
	box-sizing: border-box;
	background: transparent !important;

	border-radius: 5px;
	color: #606060 !important;

	width: calc(100% - 8px);

	border: 0;
	gap: 16px;
	margin: 0.25rem 4px;
	padding: 8px 18px;

	:hover {
		background: #f0f2ff !important;
	}
`;

export const FilterButton = styled.button`
	background: transparent;
	border: 0;
	padding: 8px 16px;
	border-radius: 0px;

	&.active {
		color: ${colors.mainColors.blueberry};
		font-weight: bold;
		border-bottom: 3px solid ${colors.mainColors.blueberry};
	}

	&:hover {
		background: ${colors.mainColors.white_lilac};
	}
`;
